import { render, staticRenderFns } from "./TownSelect.vue?vue&type=template&id=05a7eb67&"
import script from "./TownSelect.vue?vue&type=script&lang=js&"
export * from "./TownSelect.vue?vue&type=script&lang=js&"
import style0 from "vue-multiselect/dist/vue-multiselect.min.css?vue&type=style&index=0&prod&lang=css&"
import style1 from "./TownSelect.vue?vue&type=style&index=1&id=05a7eb67&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports